import React from 'react';
import PropTypes from 'prop-types';

const IconAvatar = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 69 69"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="Home-Screen"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-12">
        <circle id="Oval" fill="#285AFF" cx="34.5" cy="34.5" r="34.5" />
        <g id="Group-11" transform="translate(11.000000, 11.000000)">
          <ellipse
            id="Oval"
            stroke="#FFFFFF"
            strokeWidth="2"
            cx="23.5"
            cy="23.5925926"
            rx="23.5"
            ry="23.5925926"
          />
          <circle id="Oval" fill="#FFFFFF" cx="23.5" cy="18.5" r="9.5" />
          <path
            d="M28.7862425,28.3934875 C36.4277633,29.5614625 42,33.1965711 42,37.5 C42,42.7467051 33.7172679,47 23.5,47 C13.2827321,47 5,42.7467051 5,37.5 C5,33.1965711 10.5722367,29.5614625 18.2137575,28.3934875 C19.7242822,29.4082798 21.5430393,30 23.5,30 C25.3996691,30 27.1691081,29.4424188 28.6535865,28.4819871 Z"
            id="Combined-Shape"
            fill="#FFFFFF"
          />
        </g>
      </g>
    </g>
  </svg>
);

IconAvatar.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};

IconAvatar.defaultProps = {
  width: '50',
  height: '50',
};

export default IconAvatar;
